import React, { useEffect, useState, forwardRef } from 'react';

const AnimatedElement = forwardRef(({ children, delay = 0, animationClass = 'animate-fade-in' }, ref) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, delay * 1000); // Convert delay from seconds to milliseconds

    return () => clearTimeout(timeout); // Cleanup timeout on unmount
  }, [delay]);

  return (
    <div
      ref={ref} // Forward the ref to the root div
      className={`${isVisible ? animationClass : 'opacity-0'}`}
    >
      {children}
    </div>
  );
});

AnimatedElement.displayName = 'AnimatedElement'; // Set a display name for the component (useful for debugging)

export default AnimatedElement;